import {Subject} from 'rxjs/Subject';

export enum GameState {
  PREPARE = 'prepare',
  START = 'start',
  PAUSE = 'pause',
  RESUME = 'resume',
  STOP = 'stop'
}

export class GameService {

  stateObservable = new Subject();
  private _state: GameState;

  sessionCode: string = '';

  constructor() {
    this._state = GameState.PREPARE;
  }

  public set state(newState: GameState) {
    this._state = newState;
    this.stateObservable.next(newState);
  }

  public get state(): GameState {
    return this._state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/game.service.ts